import {
  ReportDashboardComponent,
  ReportDashboardComponentKind,
  ReportDashboardComponentViewMode,
  ReportDashboardMetricOptions,
} from '@core/reports-types';

export const determineAvailableViewModes = (
  x: Partial<Pick<ReportDashboardComponent, 'primaryGroup' | 'secondaryGroup'>>,
  metric: ReportDashboardMetricOptions,
): Record<ReportDashboardComponentViewMode, boolean> => {
  const primaryGroup = x.primaryGroup ?? '';
  const secondaryGroup = x.secondaryGroup ?? '';
  switch (metric.kind) {
    case ReportDashboardComponentKind.Breakdown:
      return {
        [ReportDashboardComponentViewMode.Chart]: primaryGroup !== '',
        [ReportDashboardComponentViewMode.Table]: primaryGroup !== '',
        [ReportDashboardComponentViewMode.Summary]: primaryGroup === '' || secondaryGroup === '',
      };

    case ReportDashboardComponentKind.Trend:
      return {
        [ReportDashboardComponentViewMode.Chart]: true,
        [ReportDashboardComponentViewMode.Table]: true,
        [ReportDashboardComponentViewMode.Summary]: !(primaryGroup !== ''),
      };
    case ReportDashboardComponentKind.SingleMetric:
      return {
        [ReportDashboardComponentViewMode.Chart]:
          metric.defaultGroup !== null || primaryGroup !== '',
        [ReportDashboardComponentViewMode.Table]:
          metric.defaultGroup !== null || primaryGroup !== '',
        [ReportDashboardComponentViewMode.Summary]: true,
      };

    case ReportDashboardComponentKind.Funnel:
      return {
        [ReportDashboardComponentViewMode.Chart]: true,
        [ReportDashboardComponentViewMode.Summary]: true,
        [ReportDashboardComponentViewMode.Table]: true,
      };

    case ReportDashboardComponentKind.TimeBased:
      return {
        [ReportDashboardComponentViewMode.Chart]: primaryGroup !== '',
        [ReportDashboardComponentViewMode.Table]: primaryGroup !== '',
        [ReportDashboardComponentViewMode.Summary]: true,
      };

    default:
      return {
        [ReportDashboardComponentViewMode.Chart]: false,
        [ReportDashboardComponentViewMode.Summary]: false,
        [ReportDashboardComponentViewMode.Table]: true,
      };
  }
};

export const isViewModeAvailable = (
  metric: ReportDashboardMetricOptions,
  viewMode: ReportDashboardComponentViewMode,
  component: { primaryGroup?: string | null; secondaryGroup?: string | null },
): boolean => determineAvailableViewModes(component, metric)[viewMode] ?? false;
